/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import { CircleDollarSign, Save, Loader2, Plus, Trash2 } from "lucide-react";
import apicache from "../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

const PREDEFINED_CURRENCIES = [
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "USD", name: "Dollar américain", symbol: "$" },
  { code: "DZD", name: "Dinar algérien", symbol: "د.ج" },
  { code: "MAD", name: "Dirham marocain", symbol: "د.م" },
  { code: "TND", name: "Dinar tunisien", symbol: "د.ت" },
  { code: "EGP", name: "Livre égyptienne", symbol: "ج.م" },
  { code: "SAR", name: "Riyal saoudien", symbol: "ر.س" },
  { code: "AED", name: "Dirham des EAU", symbol: "د.إ" },
  { code: "QAR", name: "Riyal qatari", symbol: "ر.ق" },
  { code: "KWD", name: "Dinar koweïtien", symbol: "د.ك" },
  { code: "BHD", name: "Dinar bahreïni", symbol: "د.ب" },
  { code: "OMR", name: "Rial omanais", symbol: "ر.ع" },
  { code: "JOD", name: "Dinar jordanien", symbol: "د.أ" },
  { code: "LYD", name: "Dinar libyen", symbol: "د.ل" },
];

function DigitalCurrency() {
  const digitalStore = useSelector((state) => state.digitalStoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useStoreFormDraft(digitalStore);
  const [showSideBar, setShowSideBar] = useState(true);
  const { t, i18n } = useTranslation();
  const baseCurrency = data.digitalCurrencySettings?.baseCurrency || {};
  const additionalCurrencies = data.digitalCurrencySettings?.additionalCurrencies || [];
  const setCurrencyField = (key, value) => setData((previous) => ({
    ...previous,
    digitalCurrencySettings: {
      ...previous.digitalCurrencySettings,
      [key]: typeof value === "function"
        ? value(previous.digitalCurrencySettings?.[key] || []) : value,
    },
  }));
  const setBaseCurrency = (value) => setCurrencyField("baseCurrency", value);
  const setAdditionalCurrencies = (value) => setCurrencyField("additionalCurrencies", value);
  const [newCurrency, setNewCurrency] = useState({
    code: "",
    name: "",
    symbol: "",
    rate: "",
    isCustom: false,
  });
  const [showAddCurrency, setShowAddCurrency] = useState(false);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const message = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title:
          t("services.contact_for_free_trial"),
        showCancelButton: true,
        confirmButtonText: t("ship.yes"),
        cancelButtonText: t("ship.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  const handleBaseCurrencyChange = (e) => {
    const selectedCode = e.target.value;
    if (selectedCode === "custom") {
      setBaseCurrency({ code: "", name: "", symbol: "" });
    } else if (selectedCode) {
      const selectedCurrency = PREDEFINED_CURRENCIES.find(
        (c) => c.code === selectedCode
      );
      if (selectedCurrency) {
        setBaseCurrency(selectedCurrency);
      }
    } else {
      setBaseCurrency({ code: "", name: "", symbol: "" });
    }
  };

  const handleAddCurrency = () => {
    if (
      newCurrency.code &&
      newCurrency.name &&
      newCurrency.symbol &&
      newCurrency.rate
    ) {
      const currencyToAdd = {
        ...newCurrency,
        rate: parseFloat(newCurrency.rate),
        id: Date.now().toString(),
      };

      setAdditionalCurrencies([...additionalCurrencies, currencyToAdd]);
      setNewCurrency({
        code: "",
        name: "",
        symbol: "",
        rate: "",
        isCustom: false,
      });
      setShowAddCurrency(false);
    } else {
      Swal.fire({
        icon: "warning",
        title: t("activationCompanies.alerts.missingData.title"),
        text: t("ui.currencyFieldsRequired"),
        confirmButtonText: t("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    }
  };

  const handleRemoveCurrency = (currencyId) => {
    setAdditionalCurrencies(
      additionalCurrencies.filter((c) => c.id !== currencyId)
    );
  };

  const handleNewCurrencySelect = (e) => {
    const selectedCode = e.target.value;
    if (selectedCode === "custom") {
      setNewCurrency({
        code: "",
        name: "",
        symbol: "",
        rate: "",
        isCustom: true,
      });
    } else if (selectedCode) {
      const selectedCurrency = PREDEFINED_CURRENCIES.find(
        (c) => c.code === selectedCode
      );
      if (selectedCurrency) {
        setNewCurrency({
          ...selectedCurrency,
          rate: "",
          isCustom: false,
        });
      }
    } else {
      setNewCurrency({
        code: "",
        name: "",
        symbol: "",
        rate: "",
        isCustom: false,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!baseCurrency.code || !baseCurrency.name || !baseCurrency.symbol) {
      Swal.fire({
        icon: "warning",
        title: t("ui.baseCurrencyRequired"),
        text: t("ui.chooseBaseCurrency"),
        confirmButtonText: t("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return;
    }

    apicache(account, products);
    setLoading(true);

    const updatedData = {
      ...data,
      digitalCurrencySettings: {
        baseCurrency,
        additionalCurrencies,
      },
    };

    try {
      await saveStoreDraft(doc(db, "digitalStore", data.id), digitalStore, updatedData).then(
      () => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: t("settings.success"),
          confirmButtonText: t("ship.ok"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      },
      (error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: t("Products.ImportModal.error"),
          text: t("ui.dataSaveFailed"),
          confirmButtonText: t("ship.ok"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    );
    } catch (error) {
      Swal.fire({ icon: "error", title: t("ui.notSaved"), confirmButtonText: t("ship.ok") });
    } finally {
      setLoading(false);
    }
  };
  const isRTL = i18n.dir() === "rtl";

  return (
    <div
      className="container-fluid bg-purple-50 min-h-screen dark:!bg-[#141414]"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          <div className="bg-white rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] flex flex-col gap-y-6 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-0 dark:text-[#b98cd6]">
                  {t("digitalCurrency.pageTitle")}
                </h2>
                <p className="text-gray-600 mb-0 dark:text-gray-300">
                  {t("digitalCurrency.pageSubtitle")}
                </p>
              </div>
            </div>
          </div>

          {!!data && (
            <form onSubmit={!!account.store ? handleSubmit : message}>
              <div className="bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] border  rounded-xl shadow-sm p-6 m-3">
                {/* تنبيه هام */}
                <div className="bg-[#fcf6ff] dark:bg-[#1e1b21] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-[#faf1ff] dark:bg-[#2a2432] rounded-full text-[#9e68ba]">
                      <CircleDollarSign size={20} />
                    </div>
                    <div>
                      <h3 className="text-[#9e68ba] dark:text-[#b583e0] font-semibold text-xl mb-1">
                        {t("digitalCurrency.alert.title")}
                      </h3>
                      <p className="text-[#9e68ba] dark:text-[#b583e0] text-sm">
                        {t("digitalCurrency.alert.description")}
                      </p>
                    </div>
                  </div>
                </div>

                {/* العملة الأساسية */}
                <div className="mb-8">
                  <h3
                    className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4"
                    dir={isRTL ? "rtl" : "ltr"}
                  >
                    {t("digitalCurrency.baseCurrency.title")}
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label
                        className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2"
                        dir={isRTL ? "rtl" : "ltr"}
                      >
                        {t(
                          "digitalCurrency.baseCurrency.fields.selectBaseCurrency.label"
                        )}
                      </label>
                      <select
                        required
                        value={
                          baseCurrency.code === "" && !baseCurrency.name
                            ? "custom"
                            : baseCurrency.code
                        }
                        onChange={handleBaseCurrencyChange}
                        className="w-full pr-4 pl-3 py-3 border border-gray-300 dark:!border-[#3c3a3d] dark:bg-[#1e1b21] dark:text-gray-200 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent"
                        dir={isRTL ? "rtl" : "ltr"}
                      >
                        <option value="">
                          {t(
                            "digitalCurrency.baseCurrency.fields.selectBaseCurrency.placeholder"
                          )}
                        </option>
                        {PREDEFINED_CURRENCIES.map((currency) => (
                          <option key={currency.code} value={currency.code}>
                            {currency.name} ({currency.symbol})
                          </option>
                        ))}
                        <option value="custom">
                          {t("digitalCurrency.manual")}
                        </option>
                      </select>
                    </div>

                    {(baseCurrency.code === "" ||
                      !PREDEFINED_CURRENCIES.find(
                        (c) => c.code === baseCurrency.code
                      )) && (
                      <>
                        <div>
                          <label
                            className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2"
                            dir={isRTL ? "rtl" : "ltr"}
                          >
                            {t(
                              "digitalCurrency.baseCurrency.fields.customCode.label"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={t(
                              "digitalCurrency.baseCurrency.fields.customCode.placeholder"
                            )}
                            value={baseCurrency.code}
                            onChange={(e) =>
                              setBaseCurrency({
                                ...baseCurrency,
                                code: e.target.value.toUpperCase(),
                              })
                            }
                            className="w-full pr-4 pl-3 py-3 border border-gray-300 dark:!border-[#3c3a3d] dark:bg-[#1e1b21] dark:text-gray-200 rounded-lg focus:ring-2 focus:ring-purple-200"
                            dir={isRTL ? "rtl" : "ltr"}
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2"
                            dir={isRTL ? "rtl" : "ltr"}
                          >
                            {t(
                              "digitalCurrency.baseCurrency.fields.customName.label"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={t(
                              "digitalCurrency.baseCurrency.fields.customName.placeholder"
                            )}
                            value={baseCurrency.name}
                            onChange={(e) =>
                              setBaseCurrency({
                                ...baseCurrency,
                                name: e.target.value,
                              })
                            }
                            className="w-full pr-4 pl-3 py-3 border border-gray-300 dark:!border-[#3c3a3d] dark:bg-[#1e1b21] dark:text-gray-200 rounded-lg focus:ring-2 focus:ring-purple-200"
                            dir={isRTL ? "rtl" : "ltr"}
                            required
                          />
                        </div>
                        <div>
                          <label
                            className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2"
                            dir={isRTL ? "rtl" : "ltr"}
                          >
                            {t(
                              "digitalCurrency.baseCurrency.fields.customSymbol.label"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={t(
                              "digitalCurrency.baseCurrency.fields.customSymbol.placeholder"
                            )}
                            value={baseCurrency.symbol}
                            onChange={(e) =>
                              setBaseCurrency({
                                ...baseCurrency,
                                symbol: e.target.value,
                              })
                            }
                            className="w-full pr-4 pl-3 py-3 border border-gray-300 dark:!border-[#3c3a3d] dark:bg-[#1e1b21] dark:text-gray-200 rounded-lg focus:ring-2 focus:ring-purple-200"
                            dir={isRTL ? "rtl" : "ltr"}
                            required
                          />
                        </div>
                      </>
                    )}
                  </div>

                  {baseCurrency.code && (
                    <div className="mt-4 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg">
                      <p
                        className="text-green-700 dark:text-green-300 text-sm"
                        dir={isRTL ? "rtl" : "ltr"}
                      >
                        {t("digitalCurrency.baseCurrency.selectedMessage", {
                          name: baseCurrency.name,
                          symbol: baseCurrency.symbol,
                        })}
                      </p>
                    </div>
                  )}
                </div>

                {/* العملات الإضافية */}
                <div className="mb-6">
                  <div className="flex justify-between items-center mb-4">
                    <h3
                      className="text-lg font-semibold text-gray-700 dark:text-gray-200"
                      dir={isRTL ? "rtl" : "ltr"}
                    >
                      {t("digitalCurrency.additionalCurrencies.title")}
                    </h3>
                    <button
                      type="button"
                      onClick={() => setShowAddCurrency(true)}
                      className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                    >
                      <Plus size={16} />
                      {t("digitalCurrency.additionalCurrencies.addButton")}
                    </button>
                  </div>

                  {/* Liste des devises supplémentaires */}
                  {additionalCurrencies.length > 0 && (
                    <div className="space-y-3">
                      {additionalCurrencies.map((currency) => (
                        <div
                          key={currency.id}
                          className="flex items-center justify-between p-4 bg-gray-50 dark:bg-[#1e1b21] rounded-lg border dark:!border-[#3c3a3d]"
                        >
                          <div className="flex-1" dir={isRTL ? "rtl" : "ltr"}>
                            <div className="flex items-center gap-4">
                              <span className="font-medium text-gray-700 dark:text-gray-300">
                                {currency.name} ({currency.symbol})
                              </span>
                              <span className="text-sm text-gray-500 dark:text-gray-400">
                                1 {currency.symbol} = {currency.rate}{" "}
                                {baseCurrency.symbol}
                              </span>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => handleRemoveCurrency(currency.id)}
                            className="text-red-500 hover:text-red-700 dark:hover:text-red-400 p-2"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {showAddCurrency && (
                    <div className="mt-4 p-4 bg-[#fcf6ff] dark:bg-[#1e1b21] text-[#9e68ba] dark:text-[#b583e0] font-bold border border-blue-200 dark:!border-[#3c3a3d] rounded-lg">
                      <h4
                        className="text-md text-[#9e68ba] dark:text-[#b583e0] font-bold mb-3"
                        dir={isRTL ? "rtl" : "ltr"}
                      >
                        {t(
                          "digitalCurrency.additionalCurrencies.addCurrencyForm.title"
                        )}
                      </h4>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label
                            className="block text-sm font-medium mb-2 dark:text-gray-300"
                            dir={isRTL ? "rtl" : "ltr"}
                          >
                            {t(
                              "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.selectCurrency.label"
                            )}
                          </label>
                          <select
                            value={
                              newCurrency.isCustom ? "custom" : newCurrency.code
                            }
                            onChange={handleNewCurrencySelect}
                            className="w-full pr-4 pl-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] text-gray-700 dark:text-gray-200 dark:bg-[#1e1b21] rounded-lg focus:ring-2 focus:ring-blue-200"
                            dir={isRTL ? "rtl" : "ltr"}
                          >
                            <option value="">
                              {t(
                                "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.selectCurrency.placeholder"
                              )}
                            </option>
                            {PREDEFINED_CURRENCIES.filter(
                              (c) => c.code !== baseCurrency.code
                            ).map((currency) => (
                              <option key={currency.code} value={currency.code}>
                                {currency.name} ({currency.symbol})
                              </option>
                            ))}
                            <option value="custom">
                              {t("digitalCurrency.manual")}
                            </option>
                          </select>
                        </div>

                        <div>
                          <label
                            className="block text-sm font-medium mb-2 dark:text-gray-300"
                            dir={isRTL ? "rtl" : "ltr"}
                          >
                            {t(
                              "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.conversionRate.label"
                            )}
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            placeholder={`${
                              baseCurrency.symbol
                                ? `مثال: 150 (1 ${
                                    newCurrency.symbol || "وحدة العملة"
                                  } = 150 ${baseCurrency.symbol})`
                                : t(
                                    "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.conversionRate.placeholder"
                                  )
                            }`}
                            value={newCurrency.rate}
                            onChange={(e) =>
                              setNewCurrency({
                                ...newCurrency,
                                rate: e.target.value,
                              })
                            }
                            className="w-full pr-4 pl-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] text-gray-700 dark:text-gray-200 dark:bg-[#1e1b21] rounded-lg focus:ring-2 focus:ring-blue-200"
                            dir={isRTL ? "rtl" : "ltr"}
                          />
                          {baseCurrency.symbol && newCurrency.rate && (
                            <p
                              className="text-xs text-gray-500 dark:text-gray-400 mt-1"
                              dir={isRTL ? "rtl" : "ltr"}
                            >
                              1 {newCurrency.symbol || t("ui.currencyUnit")} ={" "}
                              {newCurrency.rate} {baseCurrency.symbol}
                            </p>
                          )}
                        </div>

                        {newCurrency.isCustom && (
                          <>
                            <div>
                              <label
                                className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2"
                                dir={isRTL ? "rtl" : "ltr"}
                              >
                                {t(
                                  "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.customCode.label"
                                )}
                              </label>
                              <input
                                type="text"
                                placeholder={t(
                                  "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.customCode.placeholder"
                                )}
                                value={newCurrency.code}
                                onChange={(e) =>
                                  setNewCurrency({
                                    ...newCurrency,
                                    code: e.target.value.toUpperCase(),
                                  })
                                }
                                className="w-full pr-4 pl-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] dark:bg-[#1e1b21] dark:text-gray-200 rounded-lg focus:ring-2 focus:ring-blue-200"
                                dir={isRTL ? "rtl" : "ltr"}
                              />
                            </div>
                            <div>
                              <label
                                className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2"
                                dir={isRTL ? "rtl" : "ltr"}
                              >
                                {t(
                                  "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.customName.label"
                                )}
                              </label>
                              <input
                                type="text"
                                placeholder={t(
                                  "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.customName.placeholder"
                                )}
                                value={newCurrency.name}
                                onChange={(e) =>
                                  setNewCurrency({
                                    ...newCurrency,
                                    name: e.target.value,
                                  })
                                }
                                className="w-full pr-4 pl-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] dark:bg-[#1e1b21] dark:text-gray-200 rounded-lg focus:ring-2 focus:ring-blue-200"
                                dir={isRTL ? "rtl" : "ltr"}
                              />
                            </div>
                            <div className="md:col-span-2">
                              <label
                                className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-2"
                                dir={isRTL ? "rtl" : "ltr"}
                              >
                                {t(
                                  "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.customSymbol.label"
                                )}
                              </label>
                              <input
                                type="text"
                                placeholder={t(
                                  "digitalCurrency.additionalCurrencies.addCurrencyForm.fields.customSymbol.placeholder"
                                )}
                                value={newCurrency.symbol}
                                onChange={(e) =>
                                  setNewCurrency({
                                    ...newCurrency,
                                    symbol: e.target.value,
                                  })
                                }
                                className="w-full pr-4 pl-3 py-2 border border-gray-300 dark:!border-[#3c3a3d] dark:bg-[#1e1b21] dark:text-gray-200 rounded-lg focus:ring-2 focus:ring-blue-200"
                                dir={isRTL ? "rtl" : "ltr"}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      <div className="flex justify-end gap-2">
                        <button
                          type="button"
                          onClick={() => {
                            setShowAddCurrency(false);
                            setNewCurrency({
                              code: "",
                              name: "",
                              symbol: "",
                              rate: "",
                              isCustom: false,
                            });
                          }}
                          className="px-4 py-2 text-gray-600 dark:text-gray-300 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg hover:bg-gray-50 dark:hover:bg-[#2a2432]"
                        >
                          {t(
                            "digitalCurrency.additionalCurrencies.addCurrencyForm.buttons.cancel"
                          )}
                        </button>
                        <button
                          type="button"
                          onClick={handleAddCurrency}
                          className="px-4 py-2 text-white rounded-lg bg-[#9b59bf] hover:bg-[#814a9f]"
                        >
                          {t(
                            "digitalCurrency.additionalCurrencies.addCurrencyForm.buttons.add"
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* زر الحفظ */}
                <div className="flex justify-center mt-8">
                  <button
                    type="submit"
                    disabled={loading}
                    className={`py-3 px-8 rounded-lg ${
                      loading
                        ? "bg-purple-400"
                        : "bg-[#9b59bf] hover:bg-[#814a9f]"
                    } text-white font-medium flex items-center gap-2 transition-colors shadow-sm`}
                  >
                    {loading ? (
                      <>
                        <Loader2 size={18} className="animate-spin" />
                        {t("digitalCurrency.saveButton.saving")}
                      </>
                    ) : (
                      <>
                        <Save size={18} />
                        {t("digitalCurrency.saveButton.default")}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default DigitalCurrency;
